module.exports = __webpack_public_path__ + "static/media/2_en.228faf35.png";